import api from '../auth';
const slug = 'api/artikals/';

const ArtikalService = () => {
    const getArtikals = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getArtikalsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getArtikal = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteArtikal = (id) => {
        return api
            .delete(slug + `artikal/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createArtikal = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateArtikal = (id, data) => {
        return api.put(slug + `artikal/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyArtikal = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getArtikals,
        getArtikalsLazy,
        getArtikal,
        deleteArtikal,
        createArtikal,
        updateArtikal,
        getOptions,
        copyArtikal
    };
};

export default ArtikalService;
